import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useDeleteCall } from '../../lib/api/delete'
import { ListActions } from './ListActions'
import { FormModal } from '../basicForm/FormModal'
import { DeleteConfirmModal } from './DeleteConfirmModal'
import { ChildForm } from '../basicForm/ChildForm'
import { Receipts } from '../receipts/Receipts'

export const List = ({
  data,
  crud,
  envData,
  routeDetails,
  dataToDisplay,
  modSchema,
  openEditFormModal,
  setOpenEditFormModal,
  listKey,
  defaultData,
  selectEditFormModal,
  openFormEdit,
  isViewOnly,
  setIsViewOnly,
  authSession,
  isLocalEnvironment,
}) => {
  const [next, setNext] = React.useState(modSchema.form.view?.dataPerRow || 0)
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)
  const [deleteData, setDeleteData] = React.useState(null)
  const [childForm, setChildForm] = React.useState(false)
  const [childFormData, setChildFormData] = React.useState(null)
  const [parentFormData, setParentFormData] = React.useState(null)
  const [modalSchema, setModalSchema] = React.useState(null)
  const [receiptModal, setReceiptModal] = React.useState(false)
  const [receiptModalData, setReceiptModalData] = React.useState(null)

  const handleMoreData = () => {
    setNext(next + (modSchema.form.view?.dataPerRow || 0))
  }

  const openReceiptModal = (data) => {
    setReceiptModal(true)
    setReceiptModalData(data)
  }

  const closeReceiptModal = () => {
    setReceiptModal(false)
    setReceiptModalData(null)
  }

  const openChildForm = (data, modalFormSchema, parentData) => {
    setChildForm(true)
    setChildFormData(data)
    setModalSchema(modalFormSchema)
    setParentFormData(parentData)
  }

  const closeChildForm = () => {
    setChildForm(false)
    setChildFormData(null)
    setModalSchema(null)
  }

  const deleteCallMutation = useDeleteCall()

  const del = (data) => {
    setDeleteData(data)
    setDeleteConfirm(true)
  }

  const goAheadDelete = async () => {
    setDeleteData(null)
    await deleteCallMutation.mutateAsync({
      url: isLocalEnvironment + '/deleteData',
      apiEndpoint: modSchema.form.update.formAPI,
      id: deleteData[modSchema.form.update.id],
      messageTitle: modSchema.form.update.deleteMessage.title,
      message: modSchema.form.update.deleteMessage.message,
      isDynamic: true,
    })
    setDeleteConfirm(false)
  }

  return (
    <div className="trtui-col-12">
      <div className="trtui-card" style={{ padding: 0 }}>
        <div className="trtui-card-body">
          <div>
            <div
              className="trtui-table-responsive trtui-table-card trtui-mb-3"
              style={{ minHeight: '15rem' }}
            >
              <table className="trtui-table trtui-align-middle trtui-table-nowrap trtui-mb-0">
                <thead className="trtui-table-light">
                  <tr>
                    {dataToDisplay.tableHeaders.map((h, hInd) => (
                      <th key={hInd} className="trtui-sort" data-sort={h} scope="col">
                        {h}
                      </th>
                    ))}
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody className="trtui-list trtui-form-check-all">
                  {data.formData?.slice(0, next).map((d, dInd) => (
                    <tr key={dInd}>
                      {dataToDisplay.tableData.map((td, tdInd) => (
                        <td key={tdInd} className="trtui-name">
                          {modSchema.form?.view?.isPageEditor ? (
                            <a
                              href={`${d.routePath}?edit=true`}
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              {d[td]}
                            </a>
                          ) : typeof td === 'object' ? (
                            td.type && td.type === 'date' ? (
                              dayjs(d[td.field]).format('DD-MM-YYYY')
                            ) : (
                              d[td]
                            )
                          ) : (
                            d[td]
                          )}
                        </td>
                      ))}
                      {modSchema.isReceiptModule ? (
                        <td>
                          <button
                            onClick={() => openReceiptModal(d)}
                            className="trtui-btn trtui-btn-soft-primary trtui-btn-sm"
                          >
                            View Receipts
                          </button>
                        </td>
                      ) : (
                        <ListActions
                          key={dInd}
                          openEditFormModal={openEditFormModal}
                          setOpenEditFormModal={setOpenEditFormModal}
                          envData={envData}
                          routeDetails={routeDetails}
                          dataToDisplay={modSchema}
                          data={d}
                          modSchema={modSchema}
                          defaultData={defaultData}
                          selectEditFormModal={selectEditFormModal}
                          openFormEdit={openFormEdit}
                          isViewOnly={isViewOnly}
                          setIsViewOnly={setIsViewOnly}
                          authSession={authSession}
                          setDeleteConfirm={setDeleteConfirm}
                          del={del}
                          openChildForm={openChildForm}
                        />
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="trtui-d-flex trtui-justify-content-center trtui-mt-3">
              <div
                className="trtui-pagination-wrap trtui-hstack trtui-gap-2"
                style={{ display: 'flex' }}
              >
                {next < data?.formData?.length && (
                  <div className="trtui-mb-4 trtui-d-grid trtui-gap-2 trtui-text-center">
                    <button
                      type="button"
                      className="trtui-btn trtui-btn-primary"
                      onClick={handleMoreData}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          {childForm && (
            <ChildForm
              key={childFormData}
              defaultData={selectEditFormModal}
              crud={crud}
              parentData={parentFormData}
              modalSchema={modalSchema}
              childFormData={childFormData}
              envData={envData}
              closeChildForm={closeChildForm}
              isLocalEnvironment={isLocalEnvironment}
            />
          )}
          {openEditFormModal && selectEditFormModal !== null && (
            <FormModal
              id={listKey}
              crud={crud}
              setOpenFormModal={setOpenEditFormModal}
              envData={envData}
              formSchema={modSchema.form.update}
              modSchema={modSchema.form.update}
              defaultData={selectEditFormModal}
              isViewOnly={isViewOnly}
              setIsViewOnly={setIsViewOnly}
              isLocalEnvironment={isLocalEnvironment}
            />
          )}
          {deleteConfirm && (
            <DeleteConfirmModal
              setDeleteConfirm={setDeleteConfirm}
              goAheadDelete={goAheadDelete}
              deleteCallMutation={deleteCallMutation}
            />
          )}
          {receiptModal && (
            <Receipts
              setReceiptModal={setReceiptModal}
              receiptModalData={receiptModalData}
              closeReceiptModal={closeReceiptModal}
              envData={envData}
              modSchema={modSchema}
            />
          )}
        </div>
      </div>
    </div>
  )
}

List.propTypes = {
  data: PropTypes.object,
  crud: PropTypes.number,
  envData: PropTypes.object,
  routeDetails: PropTypes.object,
  dataToDisplay: PropTypes.object,
  modSchema: PropTypes.object,
  openEditFormModal: PropTypes.bool,
  setOpenEditFormModal: PropTypes.func,
  listKey: PropTypes.object,
  defaultData: PropTypes.object,
  selectEditFormModal: PropTypes.object,
  openFormEdit: PropTypes.func,
  isViewOnly: PropTypes.bool,
  setIsViewOnly: PropTypes.func,
  authSession: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
